import { Icon, merge, Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import background from '../../../assets/background2.png';
import euroWhite from '../../../assets/icons/svg/euroWhite.svg';
import homeWhite from '../../../assets/icons/svg/homeWhite.svg';
import pinWhite from '../../../assets/icons/svg/pinWhite.svg';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';

const SummaryMonLogement = (props) => {

    const {
        adresse,
        cp,
        nomCommercial,
        numero,
        prixTTC,
        tva,
        lotType,
        ville
    } = props;

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                bloc: {
                    root: {
                        background: "white",
                        padding: "10px 7px"
                    },
                },
                blocs: { root: { gap: 13 } },
                data: {
                    root: {
                        fontSize: 16,
                        lineHeight: "19px",
                        marginBottom: -3
                    },
                },
                dataLabel: {
                    root: {
                        color: "red",
                        fontSize: 16,
                        lineHeight: "19px",
                        marginBottom: -3
                    },
                },
                icon: { root: { width: 18 } },
                image: {
                    image: {
                        margin: "auto",
                        width: 18
                    }
                },
                name: {
                    root: {
                        color: "white",
                        fontSize: 30,
                        lineHeight: "36px",
                        paddingLeft: 10,
                    },
                },
                outer: {
                    root: {
                        backgroundImage: `url(${background})`,
                        backgroundSize: "cover",
                        boxShadow: "inset 300px 0px 200px rgba(0, 0, 0, 0.5)",
                        gap: 13,
                        height: 305,
                        justifyContent: "center",
                        marginLeft: -36,
                        marginRight: -36,
                        paddingLeft: 12,
                        paddingRight: 12
                    }
                },
                row: {
                    root: {
                        alignItems: "center",
                        gap: 6,
                    },
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        bloc: { root: { padding: "10px 13px" } },
                        icon: { root: { width: 24 } },
                        outer: {
                            root: {
                                height: 320,
                                marginLeft: "unset",
                                marginRight: "unset",
                                paddingLeft: 25,
                                paddingRight: 25,
                            }
                        },
                        row: { root: { gap: 13 } },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Stack styles={styles.outer}>

        <Text styles={styles.name}>{nomCommercial}</Text>

        <Stack horizontal styles={styles.row}>
            <Icon imageProps={{ src: homeWhite, styles: styles.image }} styles={styles.icon} />
            <Stack horizontal styles={styles.blocs}>
                <Stack horizontal styles={styles.bloc}>
                    <Text styles={styles.dataLabel}>Lot&nbsp;:&nbsp;</Text>
                    <Text styles={styles.data}>{numero}</Text>
                </Stack>
                <Stack horizontal styles={styles.bloc}>
                    <Text styles={styles.dataLabel}>Type&nbsp;:&nbsp;</Text>
                    <Text styles={styles.data}>{lotType}</Text>
                </Stack>
            </Stack>
        </Stack>

        <Stack horizontal styles={styles.row}>
            <Icon imageProps={{ src: euroWhite, styles: styles.image }} styles={styles.icon} />
            <Stack horizontal styles={styles.blocs}>
                <Stack horizontal styles={styles.bloc}>
                    <Text styles={styles.dataLabel}>Prix&nbsp;TTC&nbsp;:&nbsp;</Text>
                    <Text styles={styles.data}>{new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(prixTTC)}</Text>
                </Stack>
                <Stack horizontal styles={styles.bloc}>
                    <Text styles={styles.dataLabel}>TVA&nbsp;:&nbsp;</Text>
                    <Text styles={styles.data}>{new Intl.NumberFormat("fr-FR", { style: "percent", maximumFractionDigits: 2 }).format(tva)}</Text>
                </Stack>
            </Stack>
        </Stack>

        <Stack horizontal styles={styles.row}>
            <Icon imageProps={{ src: pinWhite, styles: styles.image }} styles={styles.icon} />
            <Stack horizontal styles={styles.blocs}>
                <Stack styles={styles.bloc}>
                    <Stack horizontal>
                        <Text styles={styles.dataLabel}>Adresse&nbsp;:&nbsp;</Text>
                        <Text styles={styles.data}>{adresse}</Text>
                    </Stack>
                    <Text styles={styles.data}>{cp} {ville}</Text>
                </Stack>
            </Stack>
        </Stack>

    </Stack>;

};

export default SummaryMonLogement;